import autobind from 'autobind-decorator';
import { computed, observable, action, toJS } from 'mobx';

@autobind
class HockeyMatchRankModel {
  constructor(data) {
    this.list = data;
  }

  @observable
  selectedTab = 1;

  @computed
  get rankList() {
    const { list, selectedTab } = this;

    if (list.length > 1) {
      return list[selectedTab - 1].rankings;
    } else {
      if (list.length > 0) {
        return list[0].rankings;
      } else {
        return [];
      }
    }
  }

  @computed
  get tabs() {
    const { list } = this;

    if (list.length > 1) {
      return list.map((item, idx) => {
        return { key: idx + 1, value: item.subLeagueName };
      });
    } else {
      return [];
    }
  }

  /**********************************************************
   * action
   **********************************************************/
  @action
  setSelectedTab(tab) {
    this.selectedTab = tab;
  }
}

export default HockeyMatchRankModel;
